import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Ugrađeni status veze (app-connection-status: login ekran, traka u aplikaciji). Dok je na ekranu, globalni
 * "Niste povezani na internet" modal (OfflineDetectorInterceptor) se ne otvara — status kaže isto
 * i više od toga — a ručna prijava kodom ne prikazuje svoj okvir „kod nije dostupan" (jedna poruka).
 * Namerno bez zavisnosti: injektuje se u interceptor (deo HttpClient lanca).
 */
@Injectable({ providedIn: 'root' })
export class ConnectionStatusService {
  /** Broj status komponenti na ekranu. */
  readonly mounted$ = new BehaviorSubject<number>(0);
  /** Status trenutno PRIKAZUJE problem sa vezom (ne samo da je na ekranu). */
  readonly showing$ = new BehaviorSubject<boolean>(false);

  get inlineMounted(): boolean {
    return this.mounted$.value > 0;
  }

  mount() {
    this.mounted$.next(this.mounted$.value + 1);
  }

  unmount() {
    this.mounted$.next(Math.max(0, this.mounted$.value - 1));
  }
}
